import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Button from 'components/Button/Button';
import { cn } from 'components/lib/utils';

interface IBlockMenuItemVisibilityButtonProps {
  blockType: string;
  isVisible: boolean;
  isDisabled: boolean;
  onToggle: (event: React.MouseEvent) => void;
}

const resolveTitle = (isDisabled: boolean, isVisible: boolean): string => {
  if (isDisabled) return 'Store must have at least 1 block';
  if (isVisible) return 'Hide block';
  return 'Show block';
};

export const BlockMenuItemVisibilityButton: React.FC<
  IBlockMenuItemVisibilityButtonProps
> = ({ blockType, isVisible, isDisabled, onToggle }) => (
  <Button
    type="button"
    variant="ghost"
    data-testid={`TemplatesStudio-BlockVisibility-${blockType}`}
    onClick={isDisabled ? undefined : onToggle}
    disabled={isDisabled}
    className={cn(
      'p-1 h-auto w-auto hover:bg-gray-100 rounded transition-colors group-hover/collapsible:opacity-100',
      isVisible ? 'opacity-0' : 'opacity-100'
    )}
    title={resolveTitle(isDisabled, isVisible)}
  >
    <FontAwesomeIcon
      icon={`fa-regular ${isVisible ? 'fa-eye' : 'fa-eye-slash'}`}
      className={cn(
        'text-sm text-gray-500 hover:text-gray-700',
        isDisabled && 'text-gray-400'
      )}
    />
  </Button>
);
